// test1784
(1784 && 0);
